import { Component, Input, Output, EventEmitter, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { environment } from '../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DialogModule } from 'primeng/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

export const ITEM_UNAVAILABLE = 'ITEM_UNAVAILABLE';
export const EPF_REDIRECT_PARENT_WITH_URL = 'EPF_REDIRECT_PARENT_WITH_URL';

@Component({
  selector: 'app-embedded-payment',
  imports: [
    DialogModule,
    FormsModule,
    CommonModule, ReactiveFormsModule],
  templateUrl: './embedded-payment.component.html',
  providers: [DynamicDialogRef, DynamicDialogConfig

  ],
  styleUrl: './embedded-payment.component.scss'
})
export class EmbeddedPaymentComponent implements OnChanges, OnInit {

  iframeUrl!: string;
  // token: string = '';
  iframeUrlSafe!: SafeResourceUrl;

  @Input() visible: boolean = true;
  @Input() token: string = '';
  @Output() visibleChange = new EventEmitter<boolean>();

  constructor(public config: DynamicDialogConfig, private sanitizer: DomSanitizer) {

  }

  ngOnInit(): void {
    this.token = this.token;
    // console.log(this.visible, this.token)

    const rawUrl = `${environment.epfUrl}/method?token=${this.token}`;
    this.iframeUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(rawUrl);
    if (typeof window !== 'undefined') {
      window.addEventListener('message',
        (event) => {
          if (event.data?.type === 'DISABLE_CLOSE_BUTTON') {
            const button = document.getElementById('closeButton') as HTMLButtonElement;
            if (button) {
              button.disabled = true;
            }
          } else if (event.data?.type === 'ENABLE_CLOSE_BUTTON') {
            const button = document.getElementById('closeButton') as HTMLButtonElement;
            if (button) {
              button.disabled = false;
            }
          }
        });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['token'] && changes['token'].currentValue) {
      const rawUrl = `${environment.epfUrl}/method?token=${this.token}`;
      this.iframeUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(rawUrl);
      console.log('Token:', this.token);
    }
  }

  closeIframe() {
    // this.closeModal.emit();
  }

  onDialogHide() {
    this.visibleChange.emit(false);
  }

  closeDialog(): void {
    // this.closeModal.emit();
    // this.dialogRef.close();
  }


}
